var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'smartHome', params: { id: _vm.smartHome._id } },"draggable":"true"}},[_c('div',{staticClass:"smart-home__box",class:{ active: _vm.index == 0 }},[_c('p',[_vm._v(_vm._s(_vm.smartHome.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }